import { useEffect, useState } from 'react';

/**
 * The generated app, rendered in an iframe from a blob URL.
 *
 * A phone-width frame at every breakpoint, because the artifact being built is a
 * mobile-native web app and previewing it stretched to a desktop column would show
 * something no visitor will ever see.
 *
 * The object URL is revoked when the source changes: one leaks per refinement otherwise,
 * and a long editing session makes many.
 */
export default function PreviewFrame({ name, source }: { name: string; source: string }) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    const blob = new Blob([source], { type: 'text/html' });
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [source]);

  if (!url) return null;
  return (
    <div className="preview-frame">
      <iframe
        title={`Preview of ${name}`}
        src={url}
        /* allow-same-origin is deliberately absent: the app keeps its own opaque origin,
           so a generated page cannot reach the builder's localStorage or its tokens. */
        sandbox="allow-scripts allow-forms allow-modals allow-popups"
      />
    </div>
  );
}
